export default __webpack_public_path__ + "static/media/casual-life-3d-artificial-intelligence-scheme.2c145cf4.png";